export const PublicRoutePath = {
  root: "/",
  /* The v2 video landing screen. v1 has no counterpart and
     redirects to `login` — see the route in App.tsx. */
  welcome: "/welcome",
  login: "/login",
  home: "/home",
  inputTest: "/test/input",
  buttonTest: "/test/button",
  footerNavTest: "/test/footer-nav",
  /* The public, OTP-gated share-report microsite. A `:shareId`
     string, not a `(shareId) => ...` generator like MicrositeRoutePath
     below — `services/api.ts`'s `flattenRoutes` only walks string
     and plain-object values, so a function value here would be
     silently dropped and the route would NOT be recognised as public,
     defeating the whole point of listing it (T-369-31 in the 369-04
     threat model). The `:shareId` segment is turned into a wildcard
     by `flattenRoutes`, matching any concrete share id. */
  sharedReport: "/report/:shareId",
} as const;

export const MicrositeRoutePath = {
  access: '/p/access',
  error: '/p/error',
  home: (shareId: string) => `/p/${shareId}`,
  report: (shareId: string) => `/p/${shareId}/report`,
  plan: (shareId: string) => `/p/${shareId}/plan`,
  benefits: (shareId: string) => `/p/${shareId}/benefits`,
} as const;

export const SurveyRoutePath = {
  survey: (token: string) => `/survey/${token}`,
  error: '/survey/error',
} as const;

export const GuestWaiverRoutePath = {
  form: (lId: string) => `/guest-waiver/${lId}`,
} as const;
